const turnoutScores = [
  "presidential_general_turnout",
  "midterm_general_turnout",
  "presidential_primary_turnout",
  "non_presidential_primary_turnout",
  "offyear_general_turnout",
  "municipal_turnout",
  "school_board_turnout",
];



// TrueViews topic table: the default question shown per topic, and the `topic` value sent to
// /api/trueviews/*. Lives here rather than in TrueViewsSection so pages/district/tabEndpoints.js can
// read it without importing a React component.
const defaultQuestions = {
  healthcare: {
    code: "cces2012_repeal.aca",
    label: "Health Care",
    topic: "health_care",
    question:
      "Would you support or oppose repealing the entire Affordable Care Act?",
  },
  abortion: {
    code: "cces2014_abortionlateterm",
    label: "Abortion",
    topic: "abortion",
    question:
      "Do you support or oppose allowing abortions in cases of rape or incest?",
  },
  climate: {
    code: "cces2014_staterps",
    label: "Climate",
    topic: "climate",
    question:
      "Do you support or oppose state requirements for a minimum amount of renewable fuels?",
  },
  gunControl: {
    code: "cces2013_gunsbackgroundchecks",
    label: "Gun Control",
    topic: "gun_control",
    question:
      "Would you support or oppose requiring background checks for all gun purchases?",
  },
  police: {
    code: "cces2016_increasepolice",
    label: "Police and Criminal Justice",
    topic: "police_and_criminal_justice",
    question:
      "Do you support or oppose increasing the number of police officers?",
  },
  immigration: {
    code: "cces2020_imm.pathwaycitizen",
    label: "Immigration",
    topic: "immigration",
    question:
      "Do you support or oppose providing a pathway to citizenship for undocumented immigrants?",
  },
  minimumWage: {
    code: "minimumwage_15dollars",
    label: "Minimum Wage",
    topic: "minimum_wage",
    question:
      "Do you support or oppose raising the minimum wage to $15 per hour?",
  },
};

const contextBarConfig = {
  sections: {
    overview: {
      id: "overview",
    },
    turnout_scores: {
      id: "turnout_scores",
    },
    early_vote: {
      id: "early_vote",
    },
  },
};

const demographicChartTypes = {
  gender: "bar",
  party: "bar",
  ethnicity: "bar",
  // education: "pie",
  marital_status: "bar",
  age: "bar",
  partisan_bucket: "bar",
  // income: "pie",
  urbanicity: "bar",
  presidential_general_turnout_bucket: "bar",
  midterm_general_turnout_bucket: "bar",
  offyear_general_turnout_bucket: "bar",
};

const demographicCategories = Object.keys(demographicChartTypes);

// This is being used by SideBar.js
// const sections = {
//   overview: {
//     id: "overview",
//     navName: "Overview",
//     level: 1,
//   },
//   demographics: {
//     id: "demographics",
//     navName: "Demographics",
//     level: 1,
//   },
//   ...demographicCategories.reduce((acc, category) => {
//     acc[category] = {
//       id: category,
//       navName: category
//         .replace(/_/g, " ")
//         .split(" ")
//         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//         .join(" "),
//       level: 2,
//     };
//     return acc;
//   }, {}),
//   turnout_scores: {
//     id: "turnout-scores",
//     navName: "Turnout Scores",
//     level: 1,
//   },
//   turnout_scores_toplines: {
//     id: "turnout-score-toplines",
//     navName: "Toplines",
//     level: 2,
//   },
//   turnout_scores_breakout: {
//     id: "turnout-score-breakout",
//     navName: "Breakout",
//     level: 2,
//   },
//   vote_history: {
//     id: "vote_history",
//     navName: "Vote History",
//     level: 1,
//   },
//   general: {
//     id: "general",
//     navName: "General",
//     level: 2,
//   },
//   primary: {
//     id: "primary",
//     navName: "Primary",
//     level: 2,
//   },
//   minor: {
//     id: "minor",
//     navName: "Minor",
//     level: 2,
//   },
//   scores: {
//     id: "scores",
//     navName: "Scores",
//     level: 1,
//   },
//   score_distribution: {
//     id: "score-distribution",
//     navName: "Distribution",
//     level: 2,
//   },
//   score_demographics: {
//     id: "score-demographics",
//     navName: "Demographics",
//     level: 2,
//   },
//   early_vote: {
//     // {{ edit_1 }}
//     id: "early-vote",
//     navName: "Early Vote",
//     level: 1,
//   },
// };

export {
  demographicCategories,
  demographicChartTypes,
  contextBarConfig,
  defaultQuestions,
  turnoutScores,
};
